import React, { useEffect } from "react";

interface RedirectTo3DSProps {
  htmlContent: string; // Change the type to match the actual type of htmlContent
}

const RedirectTo3DS: React.FC<RedirectTo3DSProps> = ({ htmlContent }) => {
  useEffect(() => {
    // Set custom page title
    document.title = "Processing Payment";

    // Remove favicon by setting a blank data URL
    try {
      const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
        if (favicon) {
          favicon.href = "data:image/x-icon;base64,";
        }
    } catch (error) {}
    const handleSubmitForm = () => {
      const container = document.createElement("div");
      container.innerHTML = htmlContent;

      const form = container.querySelector("#threedsChallengeRedirectForm");
      if (form) {
        document.body.appendChild(form);

        // Type cast the form element to HTMLFormElement
        const typedForm = form as HTMLFormElement;

        typedForm.submit();
      }
    };

    handleSubmitForm();
  }, [htmlContent]);

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default RedirectTo3DS;
